import React from 'react';
import { AvailableTeacher } from 'models';
import Availability from './Availability';
import AvailableTeacherCardHeader from './AvailableTeacherCardHeader';
import { Card, styled, useMediaQuery } from '@mui/material';
import { Colors } from 'library';
import theme from 'theme';

export default function AvailableTeacherCard({
    teacher,
    requestToBook,
}: {
    teacher: AvailableTeacher;
    requestToBook: (teacher: AvailableTeacher, lower: string, upper: string, timezone?: string) => void;
}) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    return (
        <StyledCard small={small}>
            <AvailableTeacherCardHeader worker={teacher} />
            <MainColumn>
                <Availability teacher={teacher} requestToBook={requestToBook} />
            </MainColumn>
        </StyledCard>
    );
}

const StyledCard = styled(Card)(({ small }: { small: boolean }) => ({
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginRight: small ? 0 : 20,
    marginBottom: small ? 20 : 0,
    width: small ? '100%' : '600px',
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.darkNavy}`,
}));

const Column = styled('div')({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
});

const MainColumn = styled(Column)({
    height: '45%',
    marginBottom: 20,
    backgroundColor: Colors.white,
});
